import { isCarInUse } from "_helperFunctions/isCarInUse";
import _ from "lodash";

// Helper function for numeric comparison
export const compare = (a, b) => {
    if (a < b) return -1;
    if (a > b) return 1;
    return 0;
};

// Get action zone text for a car
export function getActionZoneText(car, actionZoneData) {
    var txt = "";
    if (getActionZoneLabel(car?.Car?.ActionZoneId, actionZoneData) !== "") {
        txt = getActionZoneLabel(car?.Car?.ActionZoneId, actionZoneData);
    }
    return txt;
}
export const getCarSerialNumber = (car) => {
    if (!car) return "";

    const fullSN = car?.FullSerialNumber;
    const nonCommSN = car?.NonCommunicativeVehicle?.SerialNumber;

    if (fullSN !== undefined && fullSN !== null && fullSN !== "") {
        return fullSN;
    }

    if (nonCommSN !== undefined && nonCommSN !== null && nonCommSN !== "") {
        return nonCommSN;
    }

    return "";
};
export const getVehicleInfo = (car, deviceType, controlType) => {
    const canCommunicate = car?.CanCarCommunicate;
    const carData = car?.Car;
    const ncv = car?.NonCommunicativeVehicle;

    const getYearFromSerial = (serial) => {
        if (!serial || typeof serial !== "string") return "";
        const match = serial.match(/^[A-Z]{2}(\d{2})/i);
        if (match?.[1]) {
            return `20${match[1]}`;
        }
        return "";
    };

    if (canCommunicate && !(([deviceType.VDU3, deviceType.VDU4].includes(carData?.DevType) &&
        ((carData?.CarControlType === controlType.Fusion && carData?.BatteryLevel > 100)
            || carData?.CarControlType === controlType.GCCM))) && carData) {
        const serialNumber =
            carData?.SerialNumber ||
            carData?.CarSerialNumber ||
            car?.FullSerialNumber ||
            '0';

        return {
            serialNumber,
            make: car?.CarMake || '',
            model: car?.CarModel || '',
            year: carData?.CarYear || getYearFromSerial(serialNumber) || ''
        };
    } else if (ncv) {
        const serialNumber = ncv?.SerialNumber || '0';

        return {
            serialNumber,
            make:
                ncv?.Make ||
                ncv?.CarMake ||
                '-',
            model:
                ncv?.Model ||
                ncv?.CarModel ||
                '-',
            year:
                ncv?.Year ||
                ncv?.CarYear ||
                getYearFromSerial(serialNumber) ||
                '',
        };
    }

    return {
        serialNumber: '0',
        make: '-',
        model: '-',
        year: '',
    };
};

export function getActionZoneLabel(azID, actionZoneData) {
    if (actionZoneData && actionZoneData.length !== 0) {
        var az = _.find(actionZoneData, function (dcAZ) {
            return dcAZ.Id === azID;
        });
        if (az) {
            return az.Label ? az.Label : "";
        }
    }
    return "";
}

// Main location comparison function - works for both ListView and DataGrid
export const compareCarsByLocation = (carA, carB, actionZoneData) => {
    // if both cars are in use, sort by Course-Hole-HoleLocation
    if (isCarInUse(carA.Car) && isCarInUse(carB.Car)) {
        // Priority is Course, Hole, Location within hole
        if (carA.Car.Course !== carB.Car.Course)
            return compare(carA.Car.Course, carB.Car.Course);
        if (carA.Car.Hole !== carB.Car.Hole)
            return compare(carA.Car.Hole, carB.Car.Hole);
        return compare(carA.Car.HoleLocation || 0, carB.Car.HoleLocation || 0);
    }

    // If neither is in use, secondary sort is by AZ text (if in AZ)
    if (carA.Car.ActionZoneId || carB.Car.ActionZoneId) {
        if (carA.Car.ActionZoneId && !carB.Car.ActionZoneId)
            return -1;
        if (!carA.Car.ActionZoneId && carB.Car.ActionZoneId)
            return 1;
        return compare(getActionZoneText(carA, actionZoneData), getActionZoneText(carB, actionZoneData));
    }

    // Move cars in use to top, not in use to bottom
    if (isCarInUse(carA.Car) && !isCarInUse(carB.Car))
        return -1;
    if (!isCarInUse(carA.Car) && isCarInUse(carB.Car))
        return 1;

    // Both have same status, sort by car number as fallback
    return compare(carA.Car.CarNumber || 0, carB.Car.CarNumber || 0);
};

// Battery comparison function
export const compareBatteries = (carA, carB) => {
    // Handle different data structures - sometimes it's carA.Car, sometimes it's just carA
    const carDataA = carA?.Car || carA;
    const carDataB = carB?.Car || carB;

    if (carDataA.IsCharging && !carDataB.IsCharging)
        return 1;
    else if (!carDataA.IsCharging && carDataB.IsCharging)
        return -1;
    return compare(carDataA.BatteryLevel, carDataB.BatteryLevel);
};

// Pace comparison function
export const comparePace = (carA, carB) => {
    // Handle different data structures - sometimes it's carA.Car, sometimes it's just carA
    const carDataA = carA?.Car || carA;
    const carDataB = carB?.Car || carB;

    // Move cars not in use to bottom or top of list (for asc/desc order)
    if (isCarInUse(carDataA) && !isCarInUse(carDataB))
        return -1;
    if (!isCarInUse(carDataA) && isCarInUse(carDataB))
        return 1;

    // Group by course
    if (carDataA.Course && !carDataB.Course)
        return -1;
    if (!carDataA.Course && carDataB.Course)
        return 1;
    if (carDataA.Course !== carDataB.Course)
        return compare(carDataA.Course, carDataB.Course);

    // Within groups, sort by pace
    return compare(carDataA.Pace, carDataB.Pace);
};